export default __webpack_public_path__ + "static/media/VS.e68ae15c.png";